// Exponential backoff (with full jitter) for WebSocket reconnects — shared by
// every live-push consumer (call center, WhatsApp live) so a real backend
// outage doesn't get hammered with a reconnect attempt every 3s forever.
// Doubles each failed attempt up to MAX_MS, resets to the base delay the
// moment a connection succeeds again.
const BASE_MS = 1000;
const MAX_MS = 30000;
// "After a few, give up fully" — 6 attempts at 1s/2s/4s/8s/16s/30s caps is
// ~60s of real trying (generous for a transient blip) without retrying
// forever against a backend that's genuinely down.
const DEFAULT_MAX_ATTEMPTS = 6;

export function createReconnectBackoff({ maxAttempts = DEFAULT_MAX_ATTEMPTS } = {}) {
  let attempt = 0;
  return {
    // Delay (ms) before the next reconnect attempt, or `null` once
    // maxAttempts is exhausted — the caller must stop scheduling retries and
    // surface a terminal "gave up" state instead of looping forever.
    next() {
      if (attempt >= maxAttempts) return null;
      const cap = Math.min(BASE_MS * 2 ** attempt, MAX_MS);
      attempt += 1;
      // Full jitter (0..cap, not cap±jitter) — spreads many open tabs/clients'
      // reconnects across the window instead of retrying in lockstep, which
      // would itself look like a thundering-herd spike to a recovering server.
      return Math.random() * cap;
    },
    reset() { attempt = 0; },
  };
}
